import React from "react"

const LandingPageHeader = ({ title }) => {
    return (
        <header className="header landing-page-header glass">
            <h1>{title}</h1>
        </header>
    )
}

export default LandingPageHeader
